export default "__VITE_ASSET__c046e2cb__"